import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../Modal';

const ListEditor = (props) => (
  <Modal title={props.modalTitle} subtitle={props.modalSubtitle} closeMethod={props.toggleListEditor}>
    {props.children}
  </Modal>
);

ListEditor.propTypes = {
  toggleListEditor: PropTypes.func,
  children: PropTypes.node,
  modalTitle: PropTypes.node,
  modalSubtitle: PropTypes.node,
};

export default ListEditor;



// WEBPACK FOOTER //
// ./app/components/FormControls/ListEditor/index.js